<script>
import Layout from "@/router/layouts/main";
import { api } from "@/state/services";
import { VclList } from "vue-content-loading";
import Calendar from "primevue/calendar";
import { exportRowsToExcel } from "@/utils/export-excel";

export default {
  components: { Layout, VclList, Calendar },
  data() {
    return {
      loading: true,
      errored: false,
      empty: false,
      regional: "team",
      total: 0,
      baseFields: [
        { key: "level", label: "Nivel", sortable: true },
        { key: "name", label: "Consultor", sortable: true },
        { key: "client", label: "Cliente", sortable: true },
        { key: "plate", label: "Placa", sortable: true },
        { key: "date", label: "Data", sortable: true },
        { key: "value", label: "Valor", sortable: true },
      ],
      items: null,
      sortBy: "date",
      sortDesc: false,
      currentPage: 1,
      perPage: "25",
      periodMonth: new Date(),
      filterType: "Cliente",
      clientFilter: "",
      consultorFilter: "",
      regionalFilter: "",
      totalBonus: 0,
      update: "",
    };
  },
  computed: {
    availableFilterTypes() {
      return this.regional === "all" ? ["Cliente", "Consultor", "Regional"] : ["Cliente", "Consultor"];
    },
    tableFields() {
      const fields = [...this.baseFields];
      if (this.regional === "all") fields.splice(2, 0, { key: "regional", label: "Regional", sortable: true });
      return fields;
    },
    filteredItems() {
      if (!this.items) return [];
      const search = this.getSearchQuery().trim().toLowerCase();
      if (!search) return this.items;
      return this.items.filter((item) => {
        if (this.filterType === "Consultor") return item.name && item.name.toLowerCase().includes(search);
        if (this.filterType === "Regional") return item.regional && item.regional.toLowerCase().includes(search);
        return item.client && item.client.toLowerCase().includes(search);
      });
    },
  },
  methods: {
    getPeriod() {
      const baseDate = this.periodMonth ? new Date(this.periodMonth) : new Date();
      return [baseDate.getFullYear(), baseDate.getMonth() + 1].join("-");
    },
    showPeriod() {
      const baseDate = this.periodMonth ? new Date(this.periodMonth) : new Date();
      return [baseDate.getMonth() + 1, baseDate.getFullYear()].join("/");
    },
    getSearchQuery() {
      if (this.filterType === "Consultor") return this.consultorFilter;
      if (this.filterType === "Regional") return this.regionalFilter;
      return this.clientFilter;
    },
    getSearchType() {
      if (this.filterType === "Consultor") return "consultor";
      if (this.filterType === "Regional") return "regional";
      return "client";
    },
    getList() {
      this.items = null;
      this.loading = true;
      this.errored = false;
      this.empty = false;
      api.get("apvs/brasil/recorrente?date=" + this.getPeriod() + "&regional=" + this.regional + "&searchQuery=" + encodeURIComponent(this.getSearchQuery()) + "&searchType=" + this.getSearchType()).then((response) => {
        if (response.data.status === "success") {
          this.items = response.data.list;
          this.total = response.data.list.length;
          this.totalBonus = response.data.total;
          this.update = response.data.update;
        }
      }).catch((error) => {
        this.errored = error;
      }).finally(() => {
        this.loading = false;
        if (this.items === "" || this.items == null) this.empty = true;
      });
    },
    exportExcel() {
      exportRowsToExcel(`apvs-brasil-recorrente-${this.getPeriod()}`, this.tableFields, this.filteredItems);
    },
  },
  mounted() {
    this.getList();
  },
  watch: {
    regional() {
      if (this.regional !== "all" && this.filterType === "Regional") {
        this.filterType = "Cliente";
        this.regionalFilter = "";
      }
      this.currentPage = 1;
      this.getList();
    },
    periodMonth() {
      this.currentPage = 1;
      this.getList();
    },
  },
};
</script>

<template>
  <Layout>
    <ol class="breadcrumb"><li class="breadcrumb-item"><router-link tag="a" to="/">Inicio</router-link></li><li class="breadcrumb-item">APVS Brasil</li><li class="breadcrumb-item d-none d-sm-block">Recorrente</li></ol>
    <div class="page-title-box d-md-flex justify-content-between mb-3"><div><h3>Recorrente</h3><p></p></div><div class="d-flex align-items-start" style="gap: 10px;"><button class="btn btn-success" @click="exportExcel"><i class="bx bx-download font-size-18 align-middle mr-1"></i>Exportar Excel</button><div v-if="update" class="font-size-11 text-right" style="line-height: 15px;"><div class="text-secondary">ULTIMA ATUALIZACAO</div><div class="text-secondary">{{ update }}</div></div></div></div>
    <div class="filter-bar d-flex mb-2"><b-dropdown variant="outline-light"><template #button-content><div><h6 class="m-0 text-secondary">Equipe</h6><div v-if="regional === 'all'">Toda rede</div><div v-else>Minha regional</div></div></template><b-dropdown-form><b-form-radio v-model="regional" value="all">Toda rede</b-form-radio></b-dropdown-form><b-dropdown-form><b-form-radio v-model="regional" value="team">Minha regional</b-form-radio></b-dropdown-form></b-dropdown><b-dropdown variant="outline-light"><template #button-content><div><h6 class="m-0 text-secondary">Filtrar periodo</h6><div>{{ showPeriod() }}</div></div></template><b-dropdown-group><Calendar v-model="periodMonth" view="month" dateFormat="yy-mm-dd" inline style="width: 250px;"></Calendar></b-dropdown-group></b-dropdown><b-dropdown variant="outline-light"><template #button-content><div><h6 class="m-0 text-secondary">Itens por pagina</h6><div>{{ perPage }} itens</div></div></template><b-dropdown-form><b-form-radio v-model="perPage" value="10">10 itens</b-form-radio></b-dropdown-form><b-dropdown-form><b-form-radio v-model="perPage" value="25">25 itens</b-form-radio></b-dropdown-form><b-dropdown-form><b-form-radio v-model="perPage" value="50">50 itens</b-form-radio></b-dropdown-form><b-dropdown-form><b-form-radio v-model="perPage" value="100">100 itens</b-form-radio></b-dropdown-form></b-dropdown></div>
    <div class="filter-bar d-flex mb-4"><div class="d-flex align-items-start w-100 filter-bar-row"><b-dropdown variant="outline-light" class="pt-1 filter-bar-type"><template #button-content><div><h6 class="m-0 text-secondary">Filtrar por</h6><div class="text-capitalize">{{ filterType }}</div></div></template><b-dropdown-form v-for="type in availableFilterTypes" :key="type"><b-form-radio v-model="filterType" :value="type">{{ type }}</b-form-radio></b-dropdown-form></b-dropdown><div class="d-flex flex-column flex-fill pt-1"><input v-if="filterType === 'Cliente'" v-model="clientFilter" type="text" class="form-control search" aria-label="Digite o nome do cliente" placeholder="Digite o nome do cliente" /><input v-else-if="filterType === 'Consultor'" v-model="consultorFilter" type="text" class="form-control search" aria-label="Digite o nome do consultor" placeholder="Digite o nome do consultor" /><input v-else v-model="regionalFilter" type="text" class="form-control search" aria-label="Digite o nome da regional" placeholder="Digite o nome da regional" /></div></div></div>
    <div class="card"><div class="card-body min-vh-25"><div class="error text-center min-vh-25" v-if="errored">Pedimos desculpas, nao podemos recuperar informacoes neste momento. Por favor, tente novamente mais tarde.</div><vcl-list v-else-if="loading" class="col-md-6"></vcl-list><div v-else-if="items && items.length === 0" class="empty text-center min-vh-25 d-flex align-items-center justify-content-center"><strong>Nenhuma movimentacao no periodo.</strong></div><div v-else class="table-responsive"><b-table stacked="md" :items="filteredItems" :fields="tableFields" class="table-nowrap table-style table-hover min-vh-25" head-variant="light" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :current-page="currentPage" :per-page="perPage" responsive><template #cell(value)="row">{{ row.item.value | currency }}</template><template #cell(bonus)="row">{{ row.item.bonus | currency }}</template></b-table></div><b-pagination class="m-0 mt-3" v-model="currentPage" :total-rows="filteredItems.length" :per-page="perPage" pills align="center"></b-pagination></div></div>
  </Layout>
</template>
